import { render, staticRenderFns } from "./TmpNav.vue?vue&type=template&id=98d5bbbe&scoped=true&"
var script = {}
import style0 from "./TmpNav.vue?vue&type=style&index=0&id=98d5bbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d5bbbe",
  null
  
)

export default component.exports